import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  name: 'FrozenColumnTest',
  setup(__props) {

const customers = ref([
    {
      "id": "C001",
      "name": "John Doe",
      "country": { "name": "United States" },
      "date": "2024-08-12",
      "company": "TechCorp",
      "status": "Active",
      "activity": "Purchase",
      "representative": { "name": "Alice Johnson" },
      "balance": 1500.75
    },
    {
      "id": "C002",
      "name": "Jane Smith",
      "country": { "name": "Canada" },
      "date": "2024-07-30",
      "company": "HealthPlus",
      "status": "Inactive",
      "activity": "Inquiry",
      "representative": { "name": "Bob Brown" },
      "balance": 250.00
    },
    {
      "id": "C003",
      "name": "Michael Lee",
      "country": { "name": "United Kingdom" },
      "date": "2024-08-05",
      "company": "FinServe",
      "status": "Active",
      "activity": "Consultation",
      "representative": { "name": "Charlie Davis" },
      "balance": 5000.00
    },
    {
      "id": "C004",
      "name": "Emily Davis",
      "country": { "name": "Australia" },
      "date": "2024-08-01",
      "company": "EduWorld",
      "status": "Pending",
      "activity": "Follow-up",
      "representative": { "name": "Diana Evans" },
      "balance": 3200.45
    },
    {
      "id": "C005",
      "name": "David Johnson",
      "country": { "name": "Germany" },
      "date": "2024-07-28",
      "company": "AutoMakers",
      "status": "Active",
      "activity": "Order",
      "representative": { "name": "Edward Harris" },
      "balance": 780.00
    }
  ]);
const balanceFrozen = ref(false);
const formatCurrency = (value) => {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

return (_ctx: any,_cache: any) => {
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ToggleButton, {
      modelValue: balanceFrozen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((balanceFrozen).value = $event)),
      onIcon: "pi pi-lock",
      offIcon: "pi pi-lock-open",
      onLabel: "Balance",
      offLabel: "Balance"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_DataTable, {
      value: customers.value,
      scrollable: "",
      scrollHeight: "400px",
      class: "mt-6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: "Name",
          style: {"min-width":"200px"},
          frozen: "",
          class: "font-bold"
        }),
        _createVNode(_component_Column, {
          field: "id",
          header: "Id",
          style: {"min-width":"100px"}
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "Name",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "country.name",
          header: "Country",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "date",
          header: "Date",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "company",
          header: "Company",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "status",
          header: "Status",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "activity",
          header: "Activity",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "representative.name",
          header: "Representative",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "balance",
          header: "Balance",
          style: {"min-width":"200px"},
          alignFrozen: "right",
          frozen: balanceFrozen.value
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(formatCurrency(data.balance)), 1)
          ]),
          _: 1
        }, 8, ["frozen"])
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}
}

})